/**
 * Component for showing a dropdonw with a country selection
 *
 */
import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Country, CountryResponse, CountryService } from '../service/country.service';

@Component({
    selector: 'selectfield-country',
    templateUrl: './input.select.country.component.html'
})
export class SelectCountryComponent implements OnInit, OnChanges {
    /**
     * Label for the field
     */
    @Input() label: string;

    /**
     * Error message ivalid input
     */
    @Input() error: string;

    /**
     * Name of the element
     */
    @Input() name: string;

    /**
     * Value for the element
     */
    @Input() value: string;

    /**
     * mandatory field or not
     */
    @Input() required: boolean;

    /**
     * Model for saving the value
     */
    @Input() model: any;

    /**
     * Class for the html-wrapper element
     */
    @Input() wrapperClass: string;

    /**
     * Language of the user
     */
    @Input() userLang: string;

    /**
     * current form element
     */
    @Input() form: FormGroup;

    /**
     * Eventemitter if the value is changed
     * @type {EventEmitter<any>}
     */
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    /**
     * List of countries
     */
    countries: Array<Country> = [];

    /**
     * constructor
     * @param countryService
     */
    constructor(private countryService: CountryService) {}

    /**
     * called if the component is initialized
     */
    public ngOnInit(): void {
        this.getCountries();
    }

    /**
     * @inheritDoc
     * @param changes
     */
    public ngOnChanges(changes: SimpleChanges) {
      if (changes.hasOwnProperty('model') && changes.model.firstChange === false) {
        // if the country changes outside this component, we have to update the selectbox
        this.form.controls[this.name].setValue(this.model);
        this.modelChange.emit(this.model);
      }
    }

  /**
     * Returns if the field is valid or not
     * @returns {boolean}
     */
    elementValid(): boolean {
        return this.form.controls[this.name].disabled ||
            this.form.controls[this.name].touched === false ||
            this.form.controls[this.name].valid === true;
    }

    /**
     * Function to update the model and inform the parent Component about it.
     * We can not use databinding here because it will not work together with
     * @param event
     */
    updateModel(event: any) {
        this.model = event.target.value;
        this.modelChange.emit(this.model);
    }

    /**
     * get countries from the service
     */
    getCountries() {
        this.countryService.getCountriesFromAPI().subscribe((response: CountryResponse) => {
            this.countries = response.data;
            // check if we have the preselected value in the list
            const formfield = this.form.get(this.name);
            const preselect = formfield.value.toUpperCase();

            if (!preselect || (preselect && this.countries.filter(country => country.code.toUpperCase() === preselect).length === 0)) {
              // preselected value ist not in the list. Reset the selection so the value is invalid
              this.updateModel({target: {value: null}});
            }
        });
    }
}
